export default function Location() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          margin: "0.5rem",
          marginTop: "1rem",
          fontFamily: "'Great Vibes', cursive",
          fontSize: "2rem",
        }}
      >
        The Gates on Roblin
      </div>
      <div
        style={{
          margin: "0.5rem",
          fontSize: "1rem",
        }}
      >
        6945 Roblin Blvd, Headingley, MB R4H 1A2
      </div>
      <iframe
        title="Embedded Google Maps component"
        width="100%"
        height="100%"
        frameBorder="0"
        style={{ border: 0, minHeight: "50vh" }}
        referrerPolicy="no-referrer-when-downgrade"
        src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_MAP_API_KEY}&q=${encodeURIComponent("The Gates On Roblin")}&region=CA`}
        allowFullScreen
      ></iframe>
    </div>
  );
}
